export const isEmptyString = (value: string): boolean =>
  value.trim().length === 0

export const isEmail = (value: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)

export const isValidPassword = (password: string): boolean => {
  /**
   * Requirements:
   * - 8 characters
   * - an upper case letter
   * - a lower case letter
   * - a number
   */
  return (
    password.length >= 8 &&
    password !== password.toLowerCase() &&
    password !== password.toUpperCase() &&
    /[0-9]/.test(password)
  )
}
